import { useEffect } from 'react'
import { LazyQueryResult } from '@apollo/client'

import {
  useGetMyBucketListsLazyQuery,
  useGetMyUpcomingBookingsWithAdventuresAndListingLazyQuery,
} from '../../hooks/useQueries'

type UseSelectEscapeData = (
  predicate: boolean
) => [
  LazyQueryResult<
    GQL_GetMyBucketListsQuery,
    Exact<{
      [key: string]: never
    }>
  >,
  LazyQueryResult<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    Exact<{
      [key: string]: never
    }>
  >
]

const useSelectEscapeData: UseSelectEscapeData = (predicate) => {
  const [loadBucketLists, bucketListResult] = useGetMyBucketListsLazyQuery()
  const [
    loadUpcomingBookings,
    bookingsResult,
  ] = useGetMyUpcomingBookingsWithAdventuresAndListingLazyQuery()

  useEffect(() => {
    if (predicate) {
      loadBucketLists()
      loadUpcomingBookings()
    }
  }, [predicate])

  return [bucketListResult, bookingsResult]
}

export default useSelectEscapeData
